// extracted by mini-css-extract-plugin
export default {"li":"Task_li__ajRDr","windowMinimized":"Task_windowMinimized__aymRk","focus":"Task_focus__RS-NL"};